import Axios from '../../helpers/api_client';
import {baseProfile, essBasicDetailsGet} from '../../api_urls';

export function fetchProfileInfo(userId) {
  return Axios.get(
    `${process.env.REACT_APP_API_GATEWAY_URL}${baseProfile}?userId=` + userId,
  ).then((res) => {
    if (res.status != 200) {
      throw res.data.message;
    }
    return res.data;
  });
}

export function updateSettings(data, userId) {
  var formData = new FormData();
  formData.append('timeZone', data.timeZone || '');
  formData.append('timeFormat', data.timeFormat || '');
  formData.append('nameFormat', data.nameFormat || '');
  formData.append('dateFormat', data.dateFormat || '');
  if (data.currentPassword !== '')
    formData.append('currentPassword', data.currentPassword);
  if (data.newPassword !== '') formData.append('newPassword', data.newPassword);
  if (data.id) {
    return Axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${baseProfile}${data.id}/`,
      formData,
      {
        headers: {
          accept: 'application/json',
          enctype: 'multipart/form-data',
        },
      },
    ).then((res) => {
      if (res.status != 200) {
        throw res.data.message;
      }
      return res.data;
    });
  } else {
    return Axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${baseProfile}?userId=` + userId,
      formData,
      {
        headers: {
          accept: 'application/json',
          enctype: 'multipart/form-data',
        },
      },
    ).then((res) => {
      if (res.status != 200) {
        throw res.data.message;
      }
      return res.data;
    });
  }
}

export function fetchUserDetails(userId) {
  return Axios.get(
    `${process.env.REACT_APP_API_GATEWAY_URL}${essBasicDetailsGet}${userId}/`,
  ).then((res) => {
    if (res.status != 200) {
      throw res.data; //throw is the diff. b/w this and next return statement
    }
    return res.data;
  });
}

//update the profile pic

export function updateProfilePic(Id, formdata) {
  return Axios.put(
    `${process.env.REACT_APP_API_GATEWAY_URL}${baseProfile}${Id}/`,
    formdata,
  ).then((res) => {
    if (res.status != 200) {
      throw res.data.message;
    }
    return res.data;
  });
}
